/* eslint-disable */

import { copy, lighten, darken } from './utils';

const fLighten = 0.6;
const fDarken = 0.6;

const c = {
  white: '#ffffff',


  black0: '#000000',
  black1: '#1F1F1F',
  black2: '#424242',
  black3: '#888888',
  black4: '#CCCCCC',
  black5: '#F2F2F2',


  primary: '#3A37BC',
  secondary: '#878787',
  coal: '#4D61A7',
  oil: '#4A9AAC',
  gas: '#ED8001',
};

export const baseColors = c;


const def = {
  bg: c.white,
  black0: c.black0,
  black1: c.black1,
  black2: c.black2,
  black3: c.black3,
  black4: c.black4,
  black5: c.black5,
  coal: c.coal,
  oil: c.oil,
  gas: c.gas,
  primary: c.primary,
  secondary: c.secondary,
};

const colorThemes = {
  default1: {
    ...def,
    name: 'default1',
  },
  meduza: {
    ...def,
    bg: '#F0EEE5',
    gas: '#D09959',
    coal: '#6185CB',
    oil: '#62AEA6',
    primary: '#837dc4', //'#6185CB',
    setBackground: true,
    forceBackground: true,
  }
};

colorThemes.custom = copy(colorThemes.default1);

let COLORS = colorThemes.default1;

function cleanColor(s) {
  let o = s.replace('#', '');
  if (o.length === 3) o = o[0] + o[0] + o[1] + o[1] + o[2] + o[2];
  return `#${o}`;
}

function updateCustomColorTheme(cs) {
  const t = colorThemes.custom;

  if (cs.bg) {
    cs.bg = cleanColor(cs.bg);
    t.bg = cs.bg;
  }
  if (cs.primary) {
    cs.primary = cleanColor(cs.primary);
    t.primary = cs.primary;
  }
  if (cs.secondary) {
    cs.secondary = cleanColor(cs.secondary);
    t.secondary = cs.secondary;
  }
}

export function setColorTheme(theme, cs = {}) {
  updateCustomColorTheme(cs);

  COLORS = colorThemes[theme];
  if (cs.bg && !COLORS.forceBackground) {
    cs.bg = cleanColor(cs.bg);
    COLORS.bg = cs.bg;
  }
  Object.keys(colorThemes).forEach((ct) => {
    document.documentElement.classList.remove(`tsg-colors-${ct}`);
  });
  document.documentElement.classList.add(`tsg-colors-${theme}`);
}

export function getColorFunc(colorDict = {}) {
  let colorFunc;
  if (Object.keys(colorDict).length === 0) {
    colorFunc = function (d, i) {
      return COLORS.divergentColors[i % COLORS.divergentColors.length];
    };
  } else {
    colorFunc = function (d) {
      return COLORS.divergentColors[colorDict[d]];
    };
  }
  return colorFunc;
}

export function getColors() {
  return COLORS;
}
